var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.6762 67.9818C84.7595 67.6435 85.2404 67.6435 85.3236 67.9818L86.432 72.4857C86.8693 74.2628 88.305 75.6202 90.1038 75.9573L93.9184 76.6722C94.281 76.7402 94.281 77.2595 93.9184 77.3275L90.1038 78.0424C88.305 78.3795 86.8693 79.7369 86.432 81.514L85.3236 86.0179C85.2404 86.3562 84.7595 86.3562 84.6762 86.0179L83.5679 81.514C83.1305 79.7369 81.6948 78.3795 79.896 78.0424L76.0814 77.3275C75.7189 77.2595 75.7189 76.7402 76.0814 76.6722L79.896 75.9573C81.6948 75.6202 83.1305 74.2628 83.5679 72.4857L84.6762 67.9818Z",
    fill: "url(#paint0_linear_45185_10392)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.527 42.1048C54.7701 41.079 56.2299 41.079 56.473 42.1048L57.7119 47.3309C59 52.7648 63.3942 56.9134 68.8931 57.8872L72.4398 58.5153C73.5406 58.7103 73.5406 60.2897 72.4398 60.4847L68.8931 61.1128C63.3942 62.0866 59 66.2352 57.7119 71.6691L56.473 76.8952C56.2299 77.921 54.7701 77.921 54.527 76.8952L53.2881 71.6691C52 66.2352 47.6058 62.0866 42.1069 61.1128L38.5602 60.4847C37.4594 60.2897 37.4594 58.7103 38.5602 58.5153L42.1069 57.8872C47.6058 56.9134 52 52.7648 53.2881 47.3309L54.527 42.1048Z",
    fill: "url(#paint1_linear_45185_10392)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45185_10392",
    x1: 84.9999,
    y1: 66.3332,
    x2: 84.9999,
    y2: 87.6665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56DB53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1968B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45185_10392",
    x1: 55.5,
    y1: 38,
    x2: 55.5,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56DB53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1968B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar5);
export default __webpack_public_path__ + "static/media/star-5.70644277c893e9079c665e8830368fbf.svg";
export { ForwardRef as ReactComponent };